import React, { useMemo } from "react";
import {
  contactIdentityPayloadFromUser,
  contactPersonEmailFromUser,
} from "../../../utils/medicalPartnerPrimaryUser";

/**
 * Read-only name + email derived from a directory User (admin partner flows).
 * Blocks duplicate “typed contact” vs primary account when used instead of free-text fields.
 *
 * @param {boolean} [embedded] If true, no inner border/bg (parent already wraps the field).
 */
function PrimaryDirectoryUserIdentityPanel({
  user,
  emptyMessage = "Select a primary user to see name and email.",
  embedded = false,
}) {
  const identity = useMemo(() => contactIdentityPayloadFromUser(user), [user]);
  const email = user ? contactPersonEmailFromUser(user) : "";

  if (!user) {
    return <p className="text-soft small mb-2">{emptyMessage}</p>;
  }

  const shellClass = embedded ? "small mb-2" : "border rounded px-3 py-2 bg-lighter small mb-2";

  return (
    <div className={shellClass}>
      <div>
        <span className="text-soft">Name: </span>
        <strong>{identity.contact_person_name || "—"}</strong>
      </div>
      <div className="text-break">
        <span className="text-soft">Email: </span>
        <strong>{email || "—"}</strong>
      </div>
      {!email ? (
        <div className="alert alert-warning py-2 mt-2 mb-0 small" role="status">
          This user has no email on file. Add one on the user profile before continuing.
        </div>
      ) : null}
    </div>
  );
}

export default PrimaryDirectoryUserIdentityPanel;
